'use client';

import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import blueshiftTheme from './blueshift-theme';

function ThemeProvider({ children }: { children: React.ReactNode }) {
  return <MuiThemeProvider theme={blueshiftTheme}>{children}</MuiThemeProvider>;
}

export default ThemeProvider;
